import { TemplateRef, Directive, inject } from '@angular/core';

@Directive({
  selector: '[selectOptions]',
  standalone: false,
})
export class SelectOptions {
  readonly template = inject<TemplateRef<any>>(TemplateRef);
}
